import logo2020 from "../../assets/img/nxtEvents/LogoVengeanceDay/VengeanceDay.png";
import logo2022 from "../../assets/img/nxtEvents/LogoVengeanceDay/VengeanceDay2022.png";
import logo2023_2024 from "../../assets/img/nxtEvents/LogoVengeanceDay/VengeanceDay2023-2024.png";
import logo2025 from "../../assets/img/nxtEvents/LogoVengeanceDay/VengeanceDay2025.png";
import logo2026 from "../../assets/img/nxtEvents/LogoVengeanceDay/VengeanceDay2026.png";

export const nxtVengeanceDayDetail = {
  "nxt-vengeance-day": {
    id: "nxt-vengeance-day",
    title: "NXT Vengeance Day",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-vengeance-day",
        items: [
          {
            id: "nxt-vengeance-day-2020",
            title: "TakeOver",
            description: "Vengeance Day 2021",
            imgUrl: logo2020,
          },
          {
            id: "nxt-vengeance-day-2022",
            title: "Vengeance Day",
            description: "NXT special episode 2022",
            imgUrl: logo2022,
          },
          {
            id: "nxt-vengeance-day-2023",
            title: "Vengeance Day",
            description: "2023 - 2024",
            imgUrl: logo2023_2024,
          },
          {
            id: "nxt-vengeance-day-2025",
            title: "Vengeance Day",
            description: "2025",
            imgUrl: logo2025,
          },
          {
            id: "nxt-vengeance-day-2026",
            title: "Vengeance Day",
            description: "2026",
            imgUrl: logo2026,
          },
        ],
      },
    ],
  },
};
